module.exports = __webpack_public_path__ + "img/money_p.bf67ea79.png";